var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"app"}},[_c('CustomNotification'),_c('ErrorLog'),_c('LayoutHeader',{staticClass:"container-fluid px-3 py-2 bg-primary"}),(_vm.$store.getters.user)?_c('RouterView',{staticClass:"flex-fill bg-white py-3"}):_c('SplashView',{staticClass:"vh-100"}),_c('LayoutFooter',{staticClass:"py-2 mt-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }